// components/discovery/GamesList.jsx
import React from 'react';
import GameCard from './GameCard';
import { useDiscovery } from '../../contexts/DiscoveryContext';

const GamesList = ({ games, loading }) => {
    const { settingsTimestamp } = useDiscovery();
    
    // Sort games by score in descending order
    const sortedGames = [...games].sort((a, b) => (b.score || 0) - (a.score || 0));

    // Show different messages based on state
    if (sortedGames.length === 0 && !loading) {
        // Only show "no results" if discovery has actually been run
        if (settingsTimestamp) {
            return (
                <div className="bg-white rounded-lg shadow p-8 text-center">
                    <div className="text-gray-600">No games found matching your criteria</div>
                    <div className="text-sm text-gray-500 mt-2">Try adjusting your filters in the sidebar</div>
                </div>
            );
        } else {
            // Show initial state when discovery hasn't been run yet
            return (
                <div className="bg-white rounded-lg shadow p-8 text-center">
                    <div className="text-gray-600">Ready to discover games</div>
                    <div className="text-sm text-gray-500 mt-2">Configure your settings in the sidebar and click "Run Discovery"</div>
                </div>
            );
        }
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {sortedGames.map(game => (
                <GameCard key={game.steamId} game={game} />
            ))}
        </div>
    );
};

export default GamesList;